/* eslint-disable react-hooks/exhaustive-deps */
import { Box, ModalProps, useTimeout } from "@chakra-ui/react";
import TraitsCanvas from "components/TraitsCanvas";
import ConfettiExplosion from "@reonomy/react-confetti-explosion";
import useApplyTraitChanges from "hooks/useApplyTraitsChanges";
import { useEffect, useMemo, useState } from "react";
import useRestoreCacheId from "hooks/useRestoreCacheId";
import SimplePopup from "components/SimplePopup";
import RefreshCountdown from "components/RefreshCountdown";

type StakeSuccessPopupProps = Omit<ModalProps, "children" | "onClose"> & {
  title: string;
  description: string;
  tokenId: number;
  currentTraits: number[];
  newTraits: number[];
  withConfetti?: boolean;
};

const StakeSuccessPopup = ({
  title,
  description,
  tokenId,
  currentTraits,
  newTraits,
  withConfetti,
  ...rest
}: StakeSuccessPopupProps) => {
  const restoreCacheId = useRestoreCacheId();
  const afterTraits = useApplyTraitChanges(currentTraits, newTraits);
  const [isReady, setIsReady] = useState(false);

  useTimeout(() => {
    setIsReady(true);
  }, 1000);

  useEffect(() => {
    restoreCacheId();
  }, []);

  const celebration = useMemo(
    () =>
      isReady && withConfetti ? (
        <Box position="absolute" left="50%" top="4rem">
          <ConfettiExplosion
            floorWidth={800}
            floorHeight={1000}
            particleCount={70}
          />
        </Box>
      ) : null,
    [isReady, withConfetti]
  );

  return (
    <SimplePopup
      title={title}
      description={description}
      onClose={() => {}}
      scrollBehavior="inside"
      size="sm"
      isClosable={false}
      {...rest}
    >
      {celebration}

      <Box pt="4">
        <TraitsCanvas traits={afterTraits} imagesSize="512" bg="dark.400" />
      </Box>

      <RefreshCountdown pt="5" />
    </SimplePopup>
  );
};

export default StakeSuccessPopup;
